import React from 'react'
import PropTypes from 'prop-types'
import { Route, Router, Switch } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { StateProvider } from '@State'
import { Toaster } from '@CommonComponents/toast'
import { ResourceSelection } from './ResourceSelection'
import { CanvasTitle } from './lmstitles/CanvasTitle'
import { BlackboardTitle } from './lmstitles/BlackBoardTitle'
import { ConnectResource } from './ConnectResource'

export const history = createBrowserHistory()

const App = ({lmsCode, contextObjId, connectedCourses, assessmentsOnly, readingLinksOnly, currentPage, contextSettings}) => {
  const initialState = {
    assessmentsOnly: assessmentsOnly,
    readingLinksOnly: readingLinksOnly,
    multiSelectEnabled: !assessmentsOnly,
    showActivities: !readingLinksOnly,
    currentPage: currentPage,
    contextObjId: contextObjId,
    coursenumToCopy: '',
    lmsCode: lmsCode,
    instrEmail: '',
    instrFirstName: '',
    instrCourses: [],
    connectedCourses: connectedCourses,
    useCourseDropDown: true,
    contextSettings: contextSettings || {},
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case 'updateInstructorData':
        return {
          ...state,
          ...action.payload,
        }
      case 'updateShowActivities':
        return {
          ...state,
          showActivities: action.showActivities,
        }
      case 'coursenumToCopy':
        return {
          ...state,
          coursenumToCopy: action.coursenumToCopy,
        }
      case 'updateConnectedCourses':
        return {
          ...state,
          connectedCourses: action.connectedCourses,
        }
      case 'updateCurrentPage':
        return {
          ...state,
          currentPage: action.currentPage,
        }
      case 'updateCourseDropDown':
        return {
          ...state,
          useCourseDropDown: action.useCourseDropDown,
        }
    }
  }

  let contextId = contextObjId;

  const getTitleComponent = (lmsCode) => {
    switch (lmsCode) {
      case 'canvas':
        return <CanvasTitle />
      case 'learn':
        return <BlackboardTitle />
      case 'BlackboardLearn':
        return <BlackboardTitle />
    }
  }

  if (
    connectedCourses.length === 0 &&
    !window.location.pathname.includes('connect_resource')
  ) {
    history.replace(
      `/lti13/resource_selection/-/${contextId}/connect_resource${window.location.search}`
    )
  }

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <Toaster />
      <div className="d-flex justify-content-center">
        {getTitleComponent(lmsCode)}
        <span
          className="fa-solid fa-exchange color_teal mt-4"
          style={{ fontSize: '25px' }}
        />
        <img
          src="/static/base_app/media/logos/wordmark-blue-300.png"
          className="ml-4"
        />
      </div>
      <div className="container col-lg-24 mt-5">
        <Router history={history}>
          <Switch>
            <Route path="/lti13/resource_selection/-/:contextId/connect_resource/" component={ConnectResource} />
            <Route path="*" component={ResourceSelection} />
          </Switch>
        </Router>
      </div>
    </StateProvider>
  )
}

App.propTypes = {
  lmsCode: PropTypes.string,
  contextObjId: PropTypes.string,
  connectedCourses: PropTypes.array,
  assessmentsOnly: PropTypes.bool,
  readingLinksOnly: PropTypes.bool,
  contextSettings: PropTypes.object,
}

export default App
